import { generatePath, useMatch } from "react-router";
import useClientContext from "../../context/useClientContext";
import { pageRoutes } from "../../routes";
import MenuLinkItem from "../common/MenuLinkItem";
import SubMenuList from "./SubMenuList";

const WorkflowsMenu = () => {
  const { clientCode, hasAnyPermission, menuBadges } = useClientContext();

  const routePattern = `/:clientCode/${pageRoutes.workflows}/:page/*`;

  const routeMatch = useMatch(routePattern);
  const currentPage = routeMatch?.params["page"];

  const buildFullPath = (page: string) => generatePath(routePattern, { clientCode, page });

  const hasAccessToWorkflows = hasAnyPermission(["ViewWorkflows", "ManageWorkflows"]);

  return (
    <SubMenuList>
      <MenuLinkItem
        subItem
        active={currentPage === pageRoutes.approvals}
        title="Approvals"
        href={buildFullPath(pageRoutes.approvals)}
        badgeCount={menuBadges?.pendingApprovalsCount}
      />
      {hasAccessToWorkflows && (
        <MenuLinkItem
          subItem
          active={currentPage === pageRoutes.workflowRuns}
          title="Workflow Runs"
          href={buildFullPath(pageRoutes.workflowRuns)}
        />
      )}
      {hasAccessToWorkflows && (
        <MenuLinkItem
          subItem
          active={currentPage === pageRoutes.workflowTemplates}
          title="Workflow Templates"
          href={buildFullPath(pageRoutes.workflowTemplates)}
        />
      )}
    </SubMenuList>
  );
};

export default WorkflowsMenu;
